import { state } from './state.js';
import { stock } from './stock.js';
import { utils } from './utils.js';
import { modals } from './modals.js';

export const cart = {
  async handleAdd() {
    const selections = state.getSelections();
    const qty = parseInt(state.elements.qtyInput.value, 10) || 1;

    if (state.steps.some(s => s.required && !selections[s.id])) {
      return utils.showFeedback(state.trad.missingRequired, 'error');
    }

    if (!Object.values(selections).some(s => s?.id_product)) {
      return utils.showFeedback(state.trad.missingSelection, 'error');
    }

    const insufficient = stock.check(qty);
    if (insufficient.length) {
      return stock.showError(insufficient);
    }

    try {
      const added = [];

      for (const step of state.steps) {
        const sel = selections[step.id];
        if (!sel?.id_product) continue;
        await utils.addToCart(sel.id_product, qty, sel.id_product_attribute);
        added.push(sel);
      }

      const image = utils.mergePreviewLayers();
      const total = Object.values(selections).reduce((t, s) => t + (s.price || 0), 0);

      const saved = await utils.savePreview(image, { selections, total });
      if (!saved?.success) return utils.showFeedback(state.trad.errorCreatingPack, 'error');

      modals.showPackModal(image, added, total);

    } catch (err) {
      console.error(err);
      utils.showFeedback(state.trad.errorCreatingPack, 'error');
    }
  }
};
